import { defineNuxtPlugin } from "#app"
import {
  GET_VISITOR_DATA,
  CLEAR_CACHE,
  FingerprintJSPro,
} from "@fingerprintjs/fingerprintjs-pro-vue-v3"
import { FpjsClient } from "@fingerprintjs/fingerprintjs-pro-spa"

export default defineNuxtPlugin((nuxtApp) => {
  // Create the client but defer script loading until getVisitorData() is first
  // called. The default fpjsPlugin calls client.init() immediately at install
  // time, which fetches an external script that can overflow JavaScriptCore's
  // call stack on iOS when loaded on pages that never use fingerprinting
  // (e.g. the join page). See issue #1407.
  const client = new FpjsClient({
    loadOptions: {
      // TODO: Un-hardcode the endpoint and scriptUrlPattern. Use the ENV variables instead.
      apiKey: "ZiVqasSymGRlYMvrTbLp",
      endpoint: [
        "https://favoritely.com/ONsOH30tKmFftdD4/AgfvAUdgS7cTKJng",
        FingerprintJSPro.defaultEndpoint,
      ],
      scriptUrlPattern: [
        "https://favoritely.com/ONsOH30tKmFftdD4/c8EgjRGzE68TGyUN?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>",
        FingerprintJSPro.defaultScriptUrlPattern,
      ],
    },
  })

  let initPromise = null
  const lazyInit = () => {
    if (!initPromise) {
      initPromise = client.init().catch((err) => {
        initPromise = null
        throw err
      })
    }
    return initPromise
  }

  const getVisitorData = async (options, ignoreCache) => {
    await lazyInit()
    return client.getVisitorData(options, ignoreCache)
  }

  const clearCache = client.clearCache.bind(client)

  nuxtApp.vueApp.provide(GET_VISITOR_DATA, getVisitorData)
  nuxtApp.vueApp.provide(CLEAR_CACHE, clearCache)
  nuxtApp.vueApp.config.globalProperties.$fpjs = { getVisitorData, clearCache }
})
